import { doc, getDoc, getFirestore } from "firebase/firestore";
import { firebaseApp } from "../../firebase/firebaseApp";

/**
 * Returns:
 *  { ok: true, config }
 *  { ok: false, reason: "missing_fields" | "not_found" | "not_allowed" | "fetch_failed" }
 *
 * Rules:
 * - clinicStudyId and subjectId are required if clinicStudyId is provided (caller decides when to call).
 * - If config.idAssociationRequired === false -> allow any subjectId (no allowlist enforcement).
 * - Otherwise (missing/true) -> enforce allowlist membership.
 */
export async function validateClinicAssociation({ clinicStudyId, subjectId }) {
  const clinic = String(clinicStudyId ?? "").trim();
  const subject = String(subjectId ?? "").trim();

  if (!clinic || !subject) {
    return { ok: false, reason: "missing_fields" };
  }

  const db = getFirestore(firebaseApp);

  try {
    const ref = doc(db, "recording_mode_configs", clinic);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      console.warn(
        `[clinic-assoc] Config not found for clinicStudyId=${clinic}`,
      );
      return { ok: false, reason: "not_found" };
    }

    const config = snap.data() ?? {};

    // Default: require association unless explicitly disabled
    const idAssociationRequired = config.idAssociationRequired !== false;

    if (!idAssociationRequired) {
      return { ok: true, config };
    }

    const allowed = Array.isArray(config.allowedIds) ? config.allowedIds : [];
    const ok = allowed.includes(subject);

    if (!ok) return { ok: false, reason: "not_allowed", config };

    return { ok: true, config };
  } catch (e) {
    console.warn("[clinic-assoc] Failed to validate association", e);
    return { ok: false, reason: "fetch_failed" };
  }
}
